/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        button: {
            paddingLeft: 0,

            _hover: {
                background: 'none'
            }
        },
        panel: {
            paddingTop: 0,
            paddingBottom: 0
        }
    },
    variants: {
        cro69: {
            container: {
                borderTopWidth: null,
                borderColor: null,
                _last: {
                    borderBottomWidth: null
                }
            },
            button: {
                fontSize: null,
                px: null,
                py: null,
                paddingLeft: null,
                justifyContent: 'space-between',
                textAlign: 'left',
                gap: 2.5,
                _focusVisible: {
                    boxShadow: null
                }
            },
            panel: {
                pt: null,
                px: null,
                pb: null,
                paddingTop: null,
                paddingBottom: null
            }
        },
        unstyled: {
            container: {
                borderTopWidth: null,
                borderColor: null,
                _last: {
                    borderBottomWidth: null
                }
            },
            button: {
                fontSize: null,
                px: null,
                py: null,
                paddingLeft: null
            },
            panel: {
                pt: null,
                px: null,
                pb: null,
                paddingTop: null,
                paddingBottom: null
            }
        },
        footer: {
            container: {
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
                borderTopWidth: null,
                _last: null
            },
            button: {
                justifyContent: 'space-between',
                px: null,
                py: null,
                paddingLeft: null
            },
            panel: {
                px: null,
                pt: null,
                pb: null,
                paddingTop: null,
                paddingBottom: null
            },
            icon: {}
        },
        countrySelector: {
            root: {
                display: 'flex',
                flexDirection: 'column',
                gap: 8
            },
            container: {
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
                borderTopWidth: null,
                _last: null
            },
            button: {
                justifyContent: 'space-between',
                px: null,
                py: null,
                paddingLeft: null
            },
            panel: {
                px: null,
                pt: null,
                pb: null,
                paddingTop: null,
                paddingBottom: null
            },
            icon: {}
        },
        refinements: ({theme}) => ({
            container: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                py: 6,
                gap: 6,
                borderTopWidth: null,
                borderBottomWidth: '1px',
                _last: {
                    borderBottomWidth: 0
                }
            },
            button: {
                // reset parent styles
                px: null,
                py: null,
                paddingLeft: null,
                // apply text styles
                ...theme.textStyles['Regular XLarge'],
                // custom styles
                justifyContent: 'space-between'
            },
            panel: {
                // reset parent styles
                pt: null,
                px: null,
                pb: null,
                paddingTop: null,
                paddingBottom: null
            },
            icon: {
                // make the icon look like figma icon size without using it
                fontSize: '1.6em',
                // need to adjust the icon height as otherwise it enlarges the button
                marginY: -1.5
            }
        })
    }
}
